module.exports = __webpack_public_path__ + "img/bet300.38cefec1.png";